import { useEffect } from "react";
import { format } from "date-fns";

import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectOverviewDateFilterState, selectSelectedModelIdState } from "../../../store/selectors/overview";
import { fetchOverviewDomains } from "../../../store/overview/slice";
import {
  selectSelectedBrandState,
  selectViewBrandIdState,
  selectBrandLoading,
} from "../../../store/selectors/brands";
import { selectModelLoading } from "../../../store/selectors/models";
import { fetchOverviewScoresFromDaily, fetchOverviewTopModel } from "../../../store/scores/slice";
import { DateSelectionMode, OverviewPeriod } from "../../../components/DatePeriodSelector/types";



export function useOverviewDataFetch(): void {
  const dispatch = useAppDispatch();
  const dateFilter = useAppSelector(selectOverviewDateFilterState);
  const selectedModelId = useAppSelector(selectSelectedModelIdState);
  const selectedBrand = useAppSelector(selectSelectedBrandState);
  const viewBrandId = useAppSelector(selectViewBrandIdState);
  const brandsLoading = useAppSelector(selectBrandLoading);
  const modelsLoading = useAppSelector(selectModelLoading);
  const hasBrandContext = selectedBrand != null || viewBrandId != null;

  useEffect(() => {
    if (brandsLoading || !hasBrandContext) return;

    const modelIdPayload = selectedModelId != null ? { model_id: selectedModelId } : {};
    
    if (dateFilter.type === DateSelectionMode.Date) {
      const datePayload = { date: format(dateFilter.dateTs, "yyyy-MM-dd") };
      dispatch(fetchOverviewScoresFromDaily({ ...datePayload, ...modelIdPayload }));
      dispatch(fetchOverviewDomains({ ...datePayload, ...modelIdPayload }));
      if (!modelsLoading) dispatch(fetchOverviewTopModel(datePayload));
    } else {
      const period: 7 | 30 = dateFilter.period === OverviewPeriod.ThirtyDays ? 30 : 7;
      const periodPayload = { period };
      dispatch(fetchOverviewScoresFromDaily({ ...periodPayload, ...modelIdPayload }));
      dispatch(fetchOverviewDomains({ ...periodPayload, ...modelIdPayload }));
      if (!modelsLoading) dispatch(fetchOverviewTopModel(periodPayload));
    }
  }, [dateFilter, dispatch, brandsLoading, hasBrandContext, selectedModelId, modelsLoading]);
}
